import { Component } from '@angular/core';

@Component({
  selector: 'app-placeholder-record-view',
  imports: [],
  templateUrl: './placeholder-record-view.component.html',
  styleUrl: './placeholder-record-view.component.css'
})
export class PlaceholderRecordViewComponent {

}
